import { useFetch } from "../../../../utils/hooks/useFetch";
import { useCallback } from "react";
import moment from "moment";
import { deleteProjectAttachment, getCreateProjectServiceConfig,getProjectDetailsServiceConfig, updateProjectServiceConfig } from "../../../../utils/services/projects";
import { getFileGroupingDetailsByUrl } from "../../../../utils/helpers";
import { useToastInfo } from "../../../../utils/hooks/useToastInfo";
import { translate } from "../../../../utils/translations/translate";
export const useProjects = () => {
    const { isError, isLoading, performAction,hideServiceError } = useFetch();
    const {toastInfo:attachmentToast,setToastInfo:setAttachmentToast} = useToastInfo();
    const createNewProject = useCallback(async (projectFormValues) => {
        try{
            const {url,options} = getCreateProjectServiceConfig(projectFormValues);
            return await performAction(url,options);
        }
        catch(e){
            console.error("Error Creating the project")
        }
        finally{
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [performAction])

    const fetchProjectDetails = useCallback(async(projectId)=>{
        try{    
            const {url,options} = getProjectDetailsServiceConfig(projectId);
            const projectDetailsResponse = await performAction(url,options);
            if(projectDetailsResponse?.Result?.ProjectID === projectId){
                const {
                    ProjectID,ProjectName,EmploymentType,ContractualPath,ResourceID,ResourceName,ManagerID,ManagerName,
                    Status,POStartDate,POEndDate,PaymentTerms,BillRate,InvoiceFrequency,ClientName,
                    ClientAddress,ClientManagerName,ClientManagerTitle,ClientManagerEmail,ClientManagerPhone,
                    VendorName,VendorAddress,TimesheetTo,InvoiceToEmail,
                    MSASignatoryName,MSASignatoryTitle,MSASignatoryEmail,MSASignatoryPhone,
                    RecruiterName,RecruiterTitle,RecruiterEmail,RecruiterPhone,
                    AccountingContactName,AccountingContactTitle,AccountingContactEmail,AccountingContactPhone,
                    EscalationContactName,EscalationContactTitle,EscalationContactEmail,EscalationContactPhone,
                    POMSA,PO_WO_SOW,VendorLetter,COI,OtherAttachments,
                } = projectDetailsResponse.Result;
                const mappedOtherAttachments = OtherAttachments?OtherAttachments.split(',').map(attachment=>{
                    return [[getFileGroupingDetailsByUrl(attachment)]]
                }):[[]]
                const savedAttachments = {
                    msa:POMSA ? [getFileGroupingDetailsByUrl(POMSA)]:[],
                    poWoSOW:PO_WO_SOW ? [getFileGroupingDetailsByUrl(PO_WO_SOW)]:[],
                    vendorLetter:VendorLetter ? [getFileGroupingDetailsByUrl(VendorLetter)]:[],
                    coi:COI ? [getFileGroupingDetailsByUrl(COI)]:[],
                    other:mappedOtherAttachments
                }
                const projectValues = {
                    resourceId: ResourceID,
                    resourceName: ResourceName,
                    projectId: ProjectID,
                    empType: EmploymentType,
                    managerName: ManagerName,
                    managerId: ManagerID,
                    status: Status,
                    projectName: ProjectName,
                    contractualPath: ContractualPath,
                    clientName: ClientName,
                    clientAddress: ClientAddress,
                    clientManagerName: ClientManagerName,
                    clientMangerTitle: ClientManagerTitle,
                    clientManagerEmail: ClientManagerEmail,
                    clientManagerPhone: ClientManagerPhone,
                    vendorName: VendorName,
                    vendorAddress: VendorAddress,
                    timesheetTo: TimesheetTo,
                    invoiceTo: InvoiceToEmail,
                    msaSignatoryTitle: MSASignatoryTitle,
                    msaSignatoryName: MSASignatoryName,
                    msaSignatoryEmail: MSASignatoryEmail,
                    msaSignatoryPhone: MSASignatoryPhone,
                    recruiterName: RecruiterName,
                    recruiterEmail: RecruiterEmail,
                    recruiterPhone: RecruiterPhone,
                    recruiterTitle: RecruiterTitle,
                    accountingContactName: AccountingContactName,
                    accountingContactEmail: AccountingContactEmail,
                    accountingContactPhone: AccountingContactPhone,
                    accountingContactTitle: AccountingContactTitle,
                    escalationContactName: EscalationContactName,
                    escalationContactEmail: EscalationContactEmail,
                    escalationContactPhone: EscalationContactPhone,
                    escalationContactTitle: EscalationContactTitle,
                    poStartDate: moment(POStartDate).format("YYYY-MM-DD"),
                    poEndDate: moment(POEndDate).format("YYYY-MM-DD"),
                    paymentTerms: PaymentTerms,
                    billRate: BillRate,
                    invoiceFrequency: InvoiceFrequency,
                    poMsa: POMSA,
                    po_wo_sow_: PO_WO_SOW,
                    vendorLetter: VendorLetter,
                    coi: COI,
                    otherAttachments: OtherAttachments,
                    savedAttachments
                };
                return projectValues;
            }
            return null;
        }
        catch(e){
            console.error("Error fetching project details");
        }
      
    },[performAction])

    const updateProject = useCallback(async(formValues)=>{
        try{
            const {url,options} = updateProjectServiceConfig(formValues);
            return await performAction(url,options);
        }
        catch(e){
            console.error('Error updating project');
        }
        finally{
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    },[performAction])
    const handleAttachmentToastClose = useCallback(()=>{
        setAttachmentToast(null);
    },[setAttachmentToast])
    const deleteAttachment = useCallback(async(projectId,fieldName,attachmentName)=>{
        try{
            const {url,options} = deleteProjectAttachment(projectId,fieldName,attachmentName);
            const response = await performAction(url,options);
            if(response.StatusCode === 200){
                setAttachmentToast({
                    message:translate('labels.attachmentSuccessToast'),
                    type:'info',
                    autoExpire:true
                })
                return true;
            }
            return false;
        }
        catch(e){
            console.error("Errror deleting the attachment");
            setAttachmentToast({
                message:e.message,
                type:"error",
                autoExpire:true
            })
            return false;
        }
    },[performAction,setAttachmentToast])
    return {
        createNewProject,
        isLoading,
        error:isError,
        attachmentToast,
        fetchProjectDetails,
        updateProject,
        handleAttachmentToastClose,
        hideServiceError,
        setAttachmentToast,
        deleteAttachment
    }
}